var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6586 3.76953L17.0531 0C16.268 1.08594 14.5297 1.84375 12.5024 1.84375C10.475 1.84375 8.73673 1.08594 7.95157 0L0.346103 3.76953C0.0375091 3.92578 -0.0874909 4.30078 0.0648529 4.60938L2.29923 9.08203C2.45548 9.39062 2.83048 9.51562 3.13907 9.36328L5.35001 8.28125C5.76407 8.07812 6.24845 8.37891 6.24845 8.84375V18.75C6.24845 19.4414 6.80704 20 7.49845 20H17.4984C18.1899 20 18.7484 19.4414 18.7484 18.75V8.83984C18.7484 8.37891 19.2328 8.07422 19.6469 8.27734L21.8578 9.35938C22.1664 9.51562 22.5414 9.39062 22.6977 9.07812L24.9359 4.60938C25.0922 4.30078 24.9672 3.92188 24.6586 3.76953Z",
    fill: "url(#paint0_linear_27_11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.56L15.26 5.56V9.32H14.244V6.648H13.012V8.84H11.996V6.648H10.516V9.32H9.5V5.56ZM9.5 12.3188L15.26 10.5588V11.6788L10.524 13.1188L15.26 14.5828V15.7028L9.5 13.9428V12.3188Z",
    fill: "#C77D7D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_11",
    x1: 12.5017,
    y1: 0,
    x2: 12.5017,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523958,
    stopColor: "#308B75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229A36"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.6a6afcdd976312da99535c8195b27683.svg";
export { ForwardRef as ReactComponent };